// Window-event contract between Tyrone and the rest of the app, kept as plain
// strings so producer features (reporting, timetable) don't back-import the
// shell — app-shell already depends on them, so that would cycle.
export const TyroneEvent = {
  open: 'tyro:open-tyrone',
  openWithPrompt: 'tyrone:open',
  openDoc: 'tyro:open-doc',
  applyWidgets: 'tyro:apply-widgets',
  removeWidgets: 'tyro:remove-widgets',
} as const;

export interface TyroneOpenEventDetail {
  prompt?: string;
  context?: {
    timetableId?: number;
  };
}

export interface TyroneOpenDocDetail {
  spaceSlug: string;
  pageSlug: string;
}
